var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "page-promotions" },
      [
        _c("div", { staticClass: "page-promotions__title" }, [
          _c("i", { staticClass: "icon-promotions" }),
          _c("h1", [_vm._v(_vm._s(_vm.$t("front.promotion.page.title")))])
        ]),
        _c("div", { staticClass: "page-promotions__filter" }, [
          _vm.promotionCategories && _vm.promotionCategories.length > 1
            ? _c(
                "ul",
                [
                  _vm.showAllCategoriesButton
                    ? _c(
                        "li",
                        {
                          class: { active: !_vm.selectedPromotionCategory },
                          on: {
                            click: function($event) {
                              _vm.selectedPromotionCategory = null
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("front.promotion.filter.all_promotions")
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._l(_vm.promotionCategories, function(category) {
                    return _c(
                      "li",
                      {
                        key: category.id,
                        class: { active: _vm.isCategoryActive(category) },
                        on: {
                          click: function($event) {
                            _vm.selectedPromotionCategory = category
                          }
                        }
                      },
                      [_vm._v(_vm._s(category.title) + "\n                ")]
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "page-promotions__list" },
          _vm._l(_vm.categoryPromotions, function(item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c(
                "div",
                {
                  staticClass: "item__content",
                  style: {
                    background: item.color,
                    "background-image":
                      "url(" +
                      item[_vm.isDeviceMobile ? "mobileImage" : "desktopImage"][
                        _vm.isWebpSupported ? "webp" : "jpg"
                      ] +
                      ")"
                  }
                },
                [
                  _c("h2", { domProps: { textContent: _vm._s(item.title) } }),
                  _c("p", {
                    domProps: { textContent: _vm._s(item.description) }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "link",
                      on: {
                        click: function($event) {
                          return _vm.showPromotion(item.slug, index)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("front.promotion.button.read_more")) +
                          "\n                    "
                      )
                    ]
                  ),
                  _c("div", { staticClass: "txt" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("front.promotion.titles.terms_and_conditions")
                        ) +
                        "\n                    "
                    )
                  ])
                ],
                1
              )
            ])
          }),
          0
        ),
        _vm.$store.state.dialogs.promotion
          ? _c(
              "v-dialog",
              {
                attrs: {
                  "content-class": "v-dialog-promotion",
                  "max-width": "780px",
                  persistent: _vm.isDialogPersistent
                },
                model: {
                  value: _vm.$store.state.dialogs.promotion,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.dialogs, "promotion", $$v)
                  },
                  expression: "$store.state.dialogs.promotion"
                }
              },
              [
                _c("promotions-popups", {
                  attrs: {
                    item: _vm.dialogItem,
                    index: _vm.promoIndex,
                    creative: _vm.promoCreative,
                    position: _vm.promoPosition
                  },
                  on: { close: _vm.closeDialog }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }